import {URL} from '../utils/axios';
import axiosInstance from '../utils/axios';

const API_URL = `${URL}/api/auth`;


export const login =async({email, password})=> {
    try {
        const response = await axiosInstance.post(`${API_URL}/login`, {email, password});
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const changePassword = async ( passwordData ) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/change-password`, passwordData);
    return response.data;
  } catch (error) {
    throw error;
  }
};